import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  rootContainer: {
    margin: "0 auto",
    marginTop: 20,
    marginBottom: 20,
    width: "50%", // Adjusted width for better responsiveness

  },
});

